module.exports = __webpack_public_path__ + "img/dribbble.71a301c6.svg";